(() => {
  'use strict';

  const buttons = document.querySelector('[data-social-login-prototype]');
  if (!buttons) return;

  // Oxi receives only the login context, never arbitrary query parameters.
  const current = new URL(window.location.href);
  const login = new URL(current.pathname, current.origin);
  if (current.searchParams.get('view') === 'oxi-prototype') {
    login.searchParams.set('view', 'oxi-prototype');
  }
  for (const key of ['checkout_url', 'return_url']) {
    const value = current.searchParams.get(key);
    if (value) login.searchParams.set(key, value);
  }
  buttons.querySelectorAll('[data-social-provider]').forEach(link => {
    const url = new URL(link.href);
    url.searchParams.set('parenturl', login.href);
    url.searchParams.set('urlparent', current.origin);
    url.searchParams.set('urlparentfull', login.href);
    const checkout = current.searchParams.get('checkout_url');
    if (checkout) url.searchParams.set('checkout_url', checkout);
    link.href = url.href;
  });
})();
